import type { Coupon } from '../../../../schema/coupon/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import { calculateCouponPrice } from './calculateCouponPrice.js';
import { calculateSportkryssPrice } from './calculateSportkryssPrice.js';

type QueryOptionsType = {
  definition: Definition;
};

/**
 * Selects the total price for a given coupon.
 *
 * @param coupon Coupon entity
 * @param root0 Should select related coupon price
 * @param root0.definition Product definition
 * @returns Total price
 */
export function calculatePrice(coupon: Coupon, { definition }: QueryOptionsType): number {
  const couponPrice = calculateCouponPrice(coupon, { definition });
  const sportkryssPrice = calculateSportkryssPrice(coupon, { definition });

  const totalPrice = couponPrice + sportkryssPrice;

  return totalPrice;
}
